import { render, staticRenderFns } from "./SportelloTabelloneEsportaView.vue?vue&type=template&id=a9da5dda&"
import script from "./SportelloTabelloneEsportaView.vue?vue&type=script&lang=ts&"
export * from "./SportelloTabelloneEsportaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports